(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-shipping-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ke-shipping-notice');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const acknowledgementKey = 'ke-shipping-notice-us-v2';
  let acknowledged = false;
  try { acknowledged = sessionStorage.getItem(acknowledgementKey) === 'yes'; } catch (_) {}
  let pending = null;
  let replaying = false;
  let previousOverflow = '';
  const accept = dialog.querySelector('[data-ke-accept]');
  const hint = dialog.querySelector('.ke-shipping-hint');
  const returnButton = dialog.querySelector('.ke-shipping-return');
  const defaultLabels = { accept: accept.textContent, hint: hint.textContent, close: returnButton.textContent };
  const gates = new Map();
  const restoreGate = (host, gate) => {
    host.inert = gate.wasInert;
    if (gate.wrapper.isConnected) gate.wrapper.replaceWith(host);
  };
  const unlockWallets = () => {
    gates.forEach((gate, host) => restoreGate(host, gate));
    gates.clear();
    observer.disconnect();
  };
  const open = (button, form, kind) => {
    if (dialog.open) return;
    pending = { button, form, kind };
    const wallet = kind === 'wallet';
    accept.textContent = wallet ? dialog.dataset.walletAccept : defaultLabels.accept;
    hint.textContent = wallet ? dialog.dataset.walletHint : defaultLabels.hint;
    returnButton.textContent = wallet ? dialog.dataset.walletClose : defaultLabels.close;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  };
  const stop = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  const scanWallets = () => {
    if (acknowledged) return;
    gates.forEach((gate, host) => {
      if (!host.isConnected) { restoreGate(host, gate); gates.delete(host); }
    });
    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons').forEach(host => {
      if (gates.has(host)) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'ke-wallet-notice-host';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ke-wallet-notice-trigger';
      trigger.setAttribute('aria-label', dialog.dataset.walletLabel);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.addEventListener('click', event => { stop(event); open(trigger, host, 'wallet'); });
      gates.set(host, { trigger, wrapper, wasInert: host.inert });
      host.before(wrapper);
      wrapper.append(host, trigger);
      host.inert = true;
    });
  };
  const observer = new MutationObserver(scanWallets);
  if (!acknowledged) {
    scanWallets();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  ['pointerdown', 'mousedown', 'touchstart'].forEach(type => {
    window.addEventListener(type, event => {
      if (!acknowledged && event.target instanceof Element && event.target.closest('.ke-wallet-notice-trigger')) event.stopImmediatePropagation();
    }, { capture: true, passive: true });
  });
  window.addEventListener('click', event => {
    if (acknowledged || !(event.target instanceof Element)) return;
    const trigger = event.target.closest('.ke-wallet-notice-trigger');
    if (!trigger) return;
    stop(event);
    open(trigger, trigger.previousElementSibling, 'wallet');
  }, true);
  document.addEventListener('click', event => {
    if (acknowledged || replaying || !(event.target instanceof Element)) return;
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button || button.disabled || !button.form) return;
    stop(event);
    open(button, button.form, 'click');
  }, true);
  document.addEventListener('submit', event => {
    if (acknowledged || replaying || !(event.target instanceof HTMLFormElement)) return;
    const button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    stop(event);
    open(button, event.target, 'submit');
  }, true);
  dialog.querySelectorAll('[data-ke-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (pending?.button.isConnected) pending.button.focus();
    pending = null;
  });
  accept.addEventListener('click', () => {
    const action = pending;
    if (!action) return;
    acknowledged = true;
    try { sessionStorage.setItem(acknowledgementKey, 'yes'); } catch (_) {}
    pending = null;
    dialog.close();
    document.documentElement.style.overflow = previousOverflow;
    unlockWallets();
    if (action.kind === 'wallet') {
      if (action.form.isConnected) {
        const priorTabIndex = action.form.getAttribute('tabindex');
        action.form.setAttribute('tabindex', '-1');
        action.form.focus({ preventScroll: true });
        action.form.addEventListener('blur', () => {
          if (priorTabIndex === null) action.form.removeAttribute('tabindex');
          else action.form.setAttribute('tabindex', priorTabIndex);
        }, { once: true });
      }
      return;
    }
    if (!action.button.isConnected || action.button.disabled || !action.form.isConnected) return;
    replaying = true;
    try {
      if (action.kind === 'click') action.button.click();
      else action.form.requestSubmit(action.button);
    } finally { replaying = false; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
